import React, { useEffect } from 'react';

function AnatomyModal({ open, onChoose }) {
  // Lock body scroll while open; user can still hit device-back / close tab.
  useEffect(() => {
    if (!open) return;
    const original = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = original; };
  }, [open]);

  if (!open) return null;

  return (
    <div className="anatomy-modal-overlay" aria-hidden="false">
      <div className="anatomy-modal" role="dialog" aria-modal="true" aria-labelledby="anatomy-modal-title">
        <h2 id="anatomy-modal-title" className="anatomy-modal-title">Which menu can we get you?</h2>
        <div className="anatomy-modal-buttons">
          <button
            type="button"
            className="anatomy-modal-tile"
            onClick={() => onChoose('V')}
            aria-label="For those with a vulva"
          >
            <span className="anatomy-modal-letter">V</span>
            <span className="anatomy-modal-subtitle">For those with a vulva</span>
          </button>
          <button
            type="button"
            className="anatomy-modal-tile"
            onClick={() => onChoose('P')}
            aria-label="For those with a penis"
          >
            <span className="anatomy-modal-letter">P</span>
            <span className="anatomy-modal-subtitle">For those with a penis</span>
          </button>
        </div>
      </div>
    </div>
  );
}

export default AnatomyModal;
